import React, { useContext } from "react";
import TablePagination from '@material-ui/core/TablePagination';
import { AppContext } from "../AppContext";

export default function Pagination(props) {
    const { page, pageLength, totalRecords, onchange } = props;
    const state = useContext(AppContext);
    const s = state.strings;

    const handleChangePage = (event, newPage) => {
        onchange(newPage + 1, state.user.settings.pagesize);
    };

    const handleChangeRowsPerPage = (event) => {
        onchange(1, event.target.value);
    };

    return (
        <TablePagination
            component="div"
            count={typeof(totalRecords) === 'number' ? totalRecords : parseInt(totalRecords)}
            page={page - 1}
            onChangePage={handleChangePage}
            rowsPerPage={typeof(pageLength) === 'number' ? pageLength : 25}
            onChangeRowsPerPage={handleChangeRowsPerPage} 
            labelRowsPerPage={s.rowsPerPage}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${s.of} ${count}`}/>
    )
}